import { Component, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { TagService } from './../../core/services/http-services/tag.service';
import { TagViewModel } from './../../core/models/view-models/tag-models/tag-view.model';
import { SortEnum } from './../../core/enums/playlist-sort.enum';
import { UIService } from '../../core/services/utils/ui.service';
import { ScreensStateService } from '../../core/services/screen-state/screens-state.service';
import { LibraryEditItemTypeEnum } from '../../core/enums/library-edit-item-type.enum';
import { AuthService } from '../../core/services/auth/auth.service';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
})
export class TagsComponent implements OnDestroy {

  @Input() sortingMode: SortEnum;
  @Input() searchValue: string;
  public libraryEditItemTypes = LibraryEditItemTypeEnum;
  public globalTags: TagViewModel[] = [];
  public sharedTags: TagViewModel[] = [];

  public availableConnectedIds: string[] = [];

  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly uiService: UIService,
    private readonly screensStateService: ScreensStateService,
    private readonly tagService: TagService,
    private readonly authService: AuthService
  ) {
    this.subscriptions.add(
      this.screensStateService.screensCollectionChanged.subscribe(
        (data) => {
          if (data) {
            (this.availableConnectedIds = data.map((x) => x.MonitorHandler));
          }
        }
      )
    );

    this.subscriptions.add(
      this.tagService.tagCollectionChanged.subscribe(
        (data: TagViewModel[]) => this.groupMonitorTags(data)
      )
    );
  }

  get ui(): UIService {
    return this.uiService;
  }

  private groupMonitorTags(tags: TagViewModel[]): void {
    this.sharedTags = [];
    this.globalTags = [];

    tags.forEach((tag: TagViewModel) => {
      if (this.authService.userId !== tag.CreatorUserId) {
        this.sharedTags.push(tag);
      } else {
        this.globalTags.push(tag);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
